import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import PropTypes from "prop-types";
import { ToolbarImpl } from "./toolbar.styles.es.js";
const propTypes = {
  background: PropTypes.oneOf(["gray", "white"]),
  children: PropTypes.node,
  variant: PropTypes.oneOf(["inline", "primary", "secondary"])
};
const defaultProps = {
  background: "white",
  children: void 0,
  variant: "primary"
};
const Toolbar = forwardRef(
  ({ background, children, variant }, forwardedRef) => /* @__PURE__ */ jsx(ToolbarImpl, { ref: forwardedRef, $background: background, $variant: variant, children })
);
Toolbar.propTypes = propTypes;
Toolbar.defaultProps = defaultProps;
export {
  Toolbar
};
